<button
  [attr.aria-label]="ariaLabel"
  [class]="
    (selected ? 'selected ' : '') +
    (disabled ? 'disabled ' : '') +
    (theme ? 'theme-' + theme : '') +
    (subtitle ? ' has-subtitle' : '') +
    (supportLongLabel ? ' support-long-label' : '')
  "
  [disabled]="disabled"
  [type]="buttonType"
  (click)="handleClick($event)"
  (mouseenter)="handleMouseEnter($event)"
  (mouseleave)="handleMouseLeave($event)"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<div *ngIf="badge" class="button-badge"></div>

<ng-template #content>
  <ng-content></ng-content>
  <ng-container *ngIf="isContentEmpty">
    <span *ngIf="label && !iconOnLeft" class="label">{{ label }}</span>

    <ng-container *ngIf="showSpinner; else iconTemplate">
      <app-pencil-spinner
        [class]="
          'pencil-icon-spinner ' + label
            ? iconOnLeft
              ? 'pencil-icon-spinner-left'
              : 'pencil-icon-spinner-right'
            : ''
        "
      >
      </app-pencil-spinner>
    </ng-container>
    <ng-template #iconTemplate>
      <app-pencil-icon
        *ngIf="icon"
        [name]="icon"
        [type]="iconConfig.type"
        [size]="iconConfig.size"
        [outlined]="iconConfig.outlined"
        [wrapperStyle]="iconConfig.wrapperStyle"
        class="pencil-icon"
      ></app-pencil-icon>
    </ng-template>
    <span *ngIf="label && iconOnLeft" class="description">
      <span class="label">{{ label }}</span>
      <span *ngIf="subtitle" class="subtitle">{{ subtitle }}</span>
    </span>
  </ng-container>
  <ng-content select="[placeAtTheEnd]"></ng-content>
</ng-template>
